<template>
  <ul class="sc-progress-steps">
    <li v-for="(step, index) in this.steps" :key="index" :style="liStyle" :class="{ 'active' : step.checked }">
      <span>{{step.text}}</span>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'ScProgressStepsComponent',
  props: {
    steps: {
      type: Array,
      required: true
    }
  },
  computed: {
    liStyle () {
      let diff = Math.floor(100 / this.steps.length)
      return { width: diff.toString() + '%' }
    }
  }
}
</script>
<style lang="scss" scoped>
$sc-progress-steps-line-color: #e5e5e5;
$sc-progress-steps-inactive-color: #455a64;
$sc-progress-steps-before-size: 36px;
$sc-progress-steps-after-top: $sc-progress-steps-before-size / 2;

.sc-progress-steps {
  counter-reset: step;

  li {
    list-style-type: none;
    float: left;
    position: relative;
    text-align: center;

    &:before {
      content: counter(step);
      counter-increment: step;
      width: $sc-progress-steps-before-size;
      height: $sc-progress-steps-before-size;
      border: 1px solid black;
      line-height: $sc-progress-steps-before-size;
      display: block;
      text-align: center;
      margin: 0px auto 25px auto;
      border-radius: 50%;
      background-color: $sc-progress-steps-inactive-color;
      color: white;
    }

    &:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 1.5px;
      background-color: $sc-progress-steps-line-color;
      top: $sc-progress-steps-after-top;
      left: -50%;
      z-index: -1;
    }

    &:first-child:after {
      content: none;
    }

    &.active:before {
      display: flex;
      justify-content: center;
      align-items: flex-end;
      font-family: smartcommerce-iconfont !important;
      content: '\F109';
      counter-reset: step;
      background-color: $sc-primary;
      border-color: $sc-primary;
      font-weight: bolder;
      font-size: 20px;
    }
  }
}
</style>
